<template>
  <div
    class="attachment-list mb-2"
  >
    <div
      class="d-flex mb-1 pa-1 pb-0 attachment-list-title"
    >
      <span
        class="text-caption text-uppercase"
      >
        Attachments
      </span>

      <v-spacer />

      <v-btn
        v-if="docketId && hasLocalFiles"
        x-small
        text
        elevation="0"
        color="grey lighten-1"
        @click="_ => downloadAllFiles()"
      >
        <v-icon
          x-small
        >
          mdi-download
        </v-icon>
        download all
      </v-btn>
    </div>

    <AttachmentListItem
      v-for="item of fileList"
      :key="item.document.id"
      :document-type="item.title"
      :notes="item.notes"
      :enable-delete="enableDelete"
      :document-id="item.id"
      :file-id="item.document.id"
      :filename="getFilename(item.document)"
      :mime-type="item.document.blob.content_type"
      :file-size="getFileSize(item.document)"
      :is-representable="item.document['representable?']"
      :created-date="getFileCreationDate(item.document)"
      @delete-file="e => $emit('delete-file', e)"
    />

    <OneDriveAttachmentItem
      v-for="spFile of sharepointFiles"
      :key="spFile.id"
      :file="spFile"
    />

    <v-snackbar
      v-model="showSnackbar"
      color="green"
      :timeout="-1"
    >
      Download in progress
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { alertHandler } from '@/alertHandler'
import { dateTimeDisplayFormat } from '@/utilities'

import { DOCKET_ENTRY_NAMESPACE } from '@/store/docket-entry'

import AttachmentListItem from './AttachmentListItem.vue'
import OneDriveAttachmentItem from './OneDriveAttachmentItem.vue'

export default {
  name: 'AttachmentList',

  components: {
    AttachmentListItem,
    OneDriveAttachmentItem,
  },

  props: {
    docketId: {
      type: Number,
      default: undefined,
    },

    enableDelete: {
      type: Boolean,
      default: false,
    },

    files: {
      type: Array,
      required: true,
    },

    sharepointFiles: {
      type: Array,
      default: () => [],
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      showSnackbar: false,
    }
  },

  computed: {
    fileList () {
      return (this.files || []).map(f => {
        if (!f.blob) return f
        return {
          document: f,
          id: undefined,
          notes: undefined,
          title: undefined,
        }
      })
    },

    hasLocalFiles () {
      return this.fileList.length > 0
    },
  },

  methods: {
    downloadAllFiles () {
      if (!this.docketId) return
      this.downloadDocketEntryAttachments(this.docketId).
        catch(error => this.displayAlert('error', error))
    },

    getFileCreationDate (file) {
      if (!(file && file.blob && file.blob.created_at)) return ''

      return dateTimeDisplayFormat(file.blob.created_at)
    },

    getFileSize (file) {
      if (!file) return undefined

      if (file && file.blob && file.blob.byte_size) return file.blob.byte_size

      return file.size ?? undefined
    },

    getFilename (file) {
      if (!file || !file.blob || !file.blob.filename) return ''
      return file.blob.filename
    },

    ...mapActions(DOCKET_ENTRY_NAMESPACE, [
      'downloadDocketEntryAttachments',
    ]),
  },
}
</script>

<style lang="scss">
.attachment-list {
  .attachment-list-title {
    border-bottom: 1px solid var(--v-background-darken1);
  }
}
</style>
